// extracted by mini-css-extract-plugin
export default {"root":"Gt5VU","appear":"xSCJ2","icon":"czUbn","title":"uObTL","body":"JLP54","close":"eFT2V"};